import './App.css';
import React from 'react';
import{CustomFooter} from "./componentes/footer"
import { CompRutas } from './navegacion/rutas';
import axios from "axios";


axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('administradoresSessionToken')}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
)

const App = () => {
  return (
    <div className="App">           
        <CompRutas />    

      </div>

  );
}

export default App;